import { IDichVuThanhToanActionTypes } from "../../action-types/dich-vu/IDichVuThanhToanActions";
import { IDichVuThanhToanReducer } from "../../reducer-model/dich-vu/IDichVuThanhToanReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDichVuThanhToanReducer = {
  status: eReducerStatusBase.is_not_initialization,
  dichVuThanhToans: [],
  idSelections: [],
  idProcessingHoaDons: [],
};
export const dichVuThanhToanReducer = (
  state: IDichVuThanhToanReducer = iniState,
  action: IDichVuThanhToanActionTypes,
): IDichVuThanhToanReducer => {
  switch (action.type) {
    case "DICH_VU_THANH_TOAN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        idSelections: [],
      };
    case "DICH_VU_THANH_TOAN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        dichVuThanhToans: action.payload,
      };
    case "DICH_VU_THANH_TOAN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_THANH_TOAN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DICH_VU_THANH_TOAN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "DICH_VU_THANH_TOAN_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_THANH_TOAN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DICH_VU_THANH_TOAN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DICH_VU_THANH_TOAN_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_THANH_TOAN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        dichVuThanhToanEditing: action.payload,
      };
    case "DICH_VU_THANH_TOAN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        dichVuThanhToanEditing: undefined,
      };
    case "DICH_VU_THANH_TOAN_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };

    case "DICH_VU_THANH_TOAN_PHAT_HANH_HOA_DON_START":
      return {
        ...state,
        idProcessingHoaDons: action.payload.ho_sos.map((x) => x.id),
      };
    case "DICH_VU_THANH_TOAN_PHAT_HANH_HOA_DON_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        idProcessingHoaDons: [],
      };
    case "DICH_VU_THANH_TOAN_PHAT_HANH_HOA_DON_ERROR":
      return {
        ...state,
        idProcessingHoaDons: [],
      };

    case "DICH_VU_THANH_TOAN_DONG_BO_HOA_DON_STATUS_START":
      return {
        ...state,
        idProcessingHoaDons: action.payload.ho_sos.map((x) => x.id),
      };
    case "DICH_VU_THANH_TOAN_DONG_BO_HOA_DON_STATUS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        idProcessingHoaDons: [],
      };
    case "DICH_VU_THANH_TOAN_DONG_BO_HOA_DON_STATUS_ERRR":
      return {
        ...state,
        idProcessingHoaDons: [],
      };
    default:
      return state;
  }
};
